export { addNewAnchor } from './addNewAnchor';
export { calcAnchorArrangementIndexInSection } from './calcAnchorArrangementIndexInSection';
export { getAnchorTarget } from './getAnchorTarget';
export { isAnchor } from './isAnchor';
export * from './components';
